import { fromJS } from 'immutable';
import * as actionTypes from '../../constants/daySheetActionTypes';

const initialState = fromJS({
  list: [],
  isLoading: false,
});

export function daySheetPaymentMethodTotalReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_DS_PAYMENT_METHOD_TOTAL: {
      return state.set('list', fromJS(action.payload));
    }
    case actionTypes.GET_DS_PAYMENT_METHOD_TOTAL_LOADING: {
      return state.set('isLoading', action.payload);
    }
    case actionTypes.CLEAR_DS_PAYMENT_METHOD_TOTAL: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export default daySheetPaymentMethodTotalReducer;
